module.exports = __webpack_public_path__ + "static/media/question.79a1ebe7.png";